import LanguagePageContainer from '@/components/language-page/LanguagePageContainer'

const BecomeTutorLanguage = () => <LanguagePageContainer variant="teach" />

export default BecomeTutorLanguage
